import { DateFormatOptions, DateHelpers } from "@accurx/shared";

export const formatDate = (s: string): string => {
    return DateHelpers.formatDate(s, DateFormatOptions.DATE_SHORT_WITH_SLASH);
};

export const formatDateShortWithHyphens = (s: string): string => {
    return DateHelpers.formatDate(s, DateFormatOptions.DATE_SHORT_WITH_HYPHENS);
};
